export const getLikes = (type, data) => {
  if (type === 'article') return data.brand.article.likes;
  return data.brand.media.likes;
};

export const increaseLikes = (type, data, isLikedByUser) => {
  if (isLikedByUser) {
    return data;
  }
  if (type === 'article') {
    // eslint-disable-next-line no-param-reassign
    data.brand.article.likes += 1;
  } else {
    // eslint-disable-next-line no-param-reassign
    data.brand.media.likes += 1;
  }

  return data;
};
